// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/update/header.css
// module id = 872
// module chunks = 41